// routes
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router-dom';
import Router from './routes';

// theme
import ThemeConfig from './theme';

// components
import ScrollToTop from './components/ScrollToTop';
import dev from './config/dev';
// ----------------------------------------------------------------------

export default function App() {
  const navigate = useNavigate();
  const handleOnIdle = event => {
    console.log('user is idle', event);
    navigate('/login', { replace: true });

  }

  const handleOnActive = event => {
  }

  const handleOnAction = event => {
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: dev.idleTimeOut,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500
  })



  return (
    <ThemeConfig>
      <ScrollToTop />
      <Router />
    </ThemeConfig>
  );
}
